import React from 'react';
const heroImageUrl = 'https://cdn.magicpatterns.com/patterns/generated-images/93ad20ad-9521-416f-87ff-c8c286f77e03.jpg';
export function Hero() {
  return <header className="px-1 pt-2 text-center" data-id="element-44" data-mp="ehtm248snfri">
      <h1 className="mx-auto max-w-[370px] text-[29px] font-extrabold leading-[1.08] tracking-[-0.055em] text-slate-950" data-id="element-45" data-mp="9k0h1ej88rst">
        Евакуатор у Києві та Київській області
      </h1>
      <p className="mx-auto mt-3 max-w-[340px] text-[13px] font-medium leading-relaxed text-slate-600" data-id="element-46" data-mp="1297esbauxdd0">
        Приїдемо швидко. Вартість погодимо з вами до виїзду.
      </p>

      <figure className="mt-5 overflow-hidden rounded-[22px] border border-slate-200 bg-slate-100 text-left" data-id="element-47" data-mp="x8jnrpmmowis">
        <img src={heroImageUrl} alt="Евакуатор перевозить автомобіль вулицею Києва" className="h-[178px] w-full object-cover object-center sm:h-[196px]" data-id="element-48" data-mp="nc87ypntxojl" />
      </figure>
    </header>;
}